enum OfferCancelledReason {
    Undefined = 0,
    CreatedByMistake = 1,
    ContactChangedMind = 2,
    ContactBudgetIssue = 3,
    ContactFoundAlternativeWorker = 4,
    ContactPositionNoLongerRequired = 5,
}

export default OfferCancelledReason;